import React from 'react';
import { Navbar, Nav, NavbarBrand, NavItem, Container, Row, Col } from 'reactstrap';
import { Link, browserHistory } from 'react-router';
import auth from './auth';
import querystring from 'query-string';

import 'bootstrap/dist/css/bootstrap.min.css';

class AdminBase extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    _onSessionChange() {
        // Change detected; wipe session
        window.sessionStorage.removeItem('session_state');
        window.sessionStorage.removeItem('access_token');
        window.location.reload();
    }

    render() {
        return (
            <div>
                <Navbar color="light" light expand>
                    <NavbarBrand className="mfg-title">
                        DDX SmartBrush - Admin Portal
                    </NavbarBrand>
                    <Nav navbar className="mfg-nav">
                        <NavItem>
                            <Link className="navbar-link" to="/admin/approvals">
                                Approvals
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link className="navbar-link" to="/admin/analytics">
                                Analytics
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link className="navbar-link" to="/admin/log">
                                Activity Log
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link className="navbar-link" to="/admin/billing">
                                Billing Management
                            </Link>
                        </NavItem>
                        <NavItem right>
                            <Link className="navbar-link" to="/admin/logout">
                                Logout
                            </Link>
                        </NavItem>
                    </Nav>

                    <span className="ml-auto">
                       <img alt="DDX logo" src="/ddx.png" width={96} height={37} />
                    </span>
                </Navbar>
                <Container>
                    <Row>
                        <Col>
                            {this.props.children}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default AdminBase;